import { apiFetch } from '..'

/**
 * オポチュニティステータス型（APIレスポンスはsnake_case）
 */
export interface OpportunityStatus {
  id: number
  name: string
  mdi_icon: string
  color: string
  is_system_managed: boolean
  is_completed: boolean
  hint: string | null
}

/**
 * オポチュニティステータス一覧レスポンス
 */
export interface GetOpportunityStatusesResponse {
  total: number
  statuses: OpportunityStatus[]
}

/**
 * クローズ理由型
 */
export interface CloseReason {
  id: number
  closeReason: string
  categoryName: string
  isAdditionalCloseReasonRequired: boolean
}

/**
 * クローズ理由一覧レスポンス
 */
export interface GetCloseReasonsResponse {
  total: number
  closeReasons: CloseReason[]
}

/**
 * ステータス更新データ
 */
export interface UpdateStatusData {
  opportunityStatusId: number
  opportunityCloseReason?: {
    opportunityCloseReasonId: number
    opportunityAdditionalCloseReason?: string | null
  }
  gCompanyName?: string | null
  gCompanyContact?: string | null
}

/**
 * ステータス更新レスポンス
 */
export interface UpdateStatusResponse {
  id: number
  opportunity_status_id: number
  opportunity_status_name: string
  opportunity_close_reason_id: number | null
  opportunity_close_reason: string | null
  opportunity_additional_close_reason: string | null
  g_company_name: string | null
  g_company_contact: string | null
  updated_at: number
}

/**
 * オポチュニティステータス一覧取得API
 */
export async function getOpportunityStatuses(params?: {
  offset?: number
  limit?: number
}): Promise<GetOpportunityStatusesResponse> {
  const queryParams = new URLSearchParams()
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/opportunity-statuses${queryString ? `?${queryString}` : ''}`

  return apiFetch(url, { method: 'GET' })
}

/**
 * オポチュニティステータス更新API
 */
export async function updateOpportunityStatus(
  opportunityId: number,
  data: UpdateStatusData,
): Promise<UpdateStatusResponse> {
  return apiFetch(`/api/opportunity/${opportunityId}/status`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

/**
 * クローズ理由一覧取得API
 */
export async function getCloseReasons(params?: { offset?: number; limit?: number }): Promise<GetCloseReasonsResponse> {
  const queryParams = new URLSearchParams()
  if (params?.offset !== undefined) {
    queryParams.append('offset', params.offset.toString())
  }
  if (params?.limit !== undefined) {
    queryParams.append('limit', params.limit.toString())
  }

  const queryString = queryParams.toString()
  const url = `/api/opportunity/close-reasons${queryString ? `?${queryString}` : ''}`

  return apiFetch(url, { method: 'GET' })
}
